import React from 'react';
import { FormattedHTMLMessage } from 'component-utilities/intl';

import defaults from './defaults.json';

const { VALIDATION_ISSUES, CONFIG } = defaults;

export { defaults };

export default function PassWordValidator(
  { withValidChars = false } = {},
  validatorConfig = CONFIG,
  validationConstants = VALIDATION_ISSUES,
) {
  const {
    SPECIAL_CHARS = {},
    LENGTH = {},
    DIGITS = {},
    LOWERCASE = {},
    UPPERCASE = {},
  } = validatorConfig;
  const validSpecChars = SPECIAL_CHARS.allowed_vals.join('');

  return {
    PasswordComplexityHint: () => (
      <FormattedHTMLMessage
        id="components.password.password_complexity"
        values={{
          length: LENGTH.min,
          lowercase: LOWERCASE.min,
          uppercase: UPPERCASE.min,
          digits: DIGITS.min,
          specialChars: SPECIAL_CHARS.min,
          validChars: withValidChars ? validSpecChars : '',
        }}
      />
    ),

    validatePassword: (password) => {
      const validationPasses = [];
      const validationIssues = [];

      function storeStatus(status, type) {
        if (status) {
          validationPasses.push(type);
        } else {
          validationIssues.push(type);
        }
      }

      function countChecker(regexp, min = 0, type) {
        const matchStatus = password.match(new RegExp(regexp, 'g')) || [];

        storeStatus(matchStatus.length >= min, type);
      }

      const specialChars = (SPECIAL_CHARS.allowed_vals || []).join('');
      const allowedChars = `a-zA-Z0-9${specialChars}`;

      // Test invalid character status
      storeStatus(
        password.match(new RegExp(`^[${allowedChars}]*$`)),
        validationConstants.INVALID_CHARS,
      );

      // Test length status
      if (LENGTH.required) {
        const lengthMin = LENGTH.min ? LENGTH.min : '';
        const lengthMax = LENGTH.max ? LENGTH.max : '';
        const lengthStatus = password.match(new RegExp(`^.{${lengthMin},${lengthMax}}$`));

        storeStatus(lengthStatus, validationConstants.LENGTH);
      }

      // Test special characters status
      if (SPECIAL_CHARS.required) {
        countChecker(`[${specialChars}]`, SPECIAL_CHARS.min, validationConstants.SPECIAL_CHARS);
      }

      // Test digits status
      if (DIGITS.required) {
        countChecker('[0-9]', DIGITS.min, validationConstants.DIGITS);
      }

      // Test lowercase status
      if (LOWERCASE.required) {
        countChecker('[a-z]', LOWERCASE.min, validationConstants.LOWERCASE);
      }

      // Test uppercase status
      if (UPPERCASE.required) {
        countChecker('[A-Z]', UPPERCASE.min, validationConstants.UPPERCASE);
      }

      return {
        validationPasses,
        validationIssues,
        isValidPassword: !!validationPasses.length && !validationIssues.length,
      };
    },
  };
}
